const MOBILE_HOME_ROUTE = ''
const MOBILE_EXPLORE_TAG = '?view=grid' // 由于 SEO 原因，手机大屏和原主页使用同一路由，这里只是为了区分不同枚举值
const MOBILE_CREATE_ROUTE = 'create'
const MOBILE_CHAT_ROUTE = 'chat'
const MOBILE_PROFILE_ROUTE = 'profile'
const APP_SEARCH_ROUTE = 'search'
export const APP_HOME_PATHNAME = `/`
export const DESKTOP_EXPLORE_PATHNAME = `/${MOBILE_HOME_ROUTE}`
export const MOBILE_EXPLORE_PATHNAME = `/${MOBILE_EXPLORE_TAG}`
export const APP_SEARCH_PATHNAME = `/${APP_SEARCH_ROUTE}`

export enum MobileFooterTag {
  Home = MOBILE_HOME_ROUTE,
  Explore = MOBILE_EXPLORE_TAG,
  Create = MOBILE_CREATE_ROUTE,
  Chat = MOBILE_CHAT_ROUTE,
  Profile = MOBILE_PROFILE_ROUTE,
}

export type AnyToVoidFunc = (...args: any[]) => void

export enum UserInitialModalStep {
  Profile = 0,
  Rules,
}
